import React from 'react';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import { ResponsiveDialog } from '@zvuk-b2b/ui-kit';
import { AdCampaignMediaTypeEnum } from '@shared/api/graphql/generated';
import MediaUploadContent from './MediaUploadContent';
import { useAdCampaignMediaViewModel } from './useAdCampaignMediaViewModel';
import { AdCampaignStepperMediaProps } from './types';
import { TEXTS } from './texts';
import { ELEMENT_IDS } from './consts';
import styles from './index.module.scss';

const AdCampaignStepperMedia: React.FC<AdCampaignStepperMediaProps> = ({
  mediaType = AdCampaignMediaTypeEnum.Audio,
  onBack,
  onNext,
  close,
  promoState,
  timeById,
  onTimeChange,
  onTimeRemove,
}) => {
  const {
    inputRef,
    isExactTime,
    isDraggable,
    acceptValue,
    uploadButtonText,
    uploadDescription,
    items,
    player,
    mediaUploadItems,
    isUploadDisabled,
    isNextDisabled,
    handleUploadClick,
    handleFilesChange,
    handleFilesSelected,
    handleRemoveClick,
    handleRetryClick,
    handleRemoveMedia,
    handleRetryMedia,
    handleVideoMediaReorder,
    handlePlayClick,
    handleTimeBlur,
    reorder,
  } = useAdCampaignMediaViewModel({ mediaType, promoState, timeById, onTimeChange, onTimeRemove });

  return (
    <ResponsiveDialog
      data-testid="modal_screen"
      open
      width={750}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) close?.();
      }}
      contentClassName={styles.container}>
      <div className={styles.headerCard}>
        <ResponsiveDialog.Header className={styles.title}>{TEXTS.TITLE}</ResponsiveDialog.Header>
        <ResponsiveDialog.Close
          id="button_modal_screen_close"
          className={styles.closeButton}
        />
      </div>
      <ResponsiveDialog.Body className={styles.content}>
        <MediaUploadContent
          inputRef={inputRef}
          isExactTime={isExactTime}
          isDraggable={isDraggable}
          acceptValue={acceptValue}
          uploadButtonText={uploadButtonText}
          uploadDescription={uploadDescription}
          items={items}
          player={player}
          mediaUploadItems={mediaUploadItems}
          isUploadDisabled={isUploadDisabled}
          handleUploadClick={handleUploadClick}
          handleFilesChange={handleFilesChange}
          handleFilesSelected={handleFilesSelected}
          handleRemoveClick={handleRemoveClick}
          handleRetryClick={handleRetryClick}
          handleRemoveMedia={handleRemoveMedia}
          handleRetryMedia={handleRetryMedia}
          handleVideoMediaReorder={handleVideoMediaReorder}
          handlePlayClick={handlePlayClick}
          handleTimeBlur={handleTimeBlur}
          reorder={reorder}
          mediaType={mediaType}
          timeById={timeById}
          onTimeChange={onTimeChange}
        />
      </ResponsiveDialog.Body>
      <ResponsiveDialog.Footer className={styles.footerCard}>
        <Button
          elementId={ELEMENT_IDS.BACK}
          type={ButtonType.SECONDARY}
          className={styles.footerButton}
          onClick={onBack}>
          {TEXTS.BACK}
        </Button>
        <Button
          elementId={ELEMENT_IDS.NEXT}
          type={ButtonType.PRIMARY}
          isDisabled={isNextDisabled}
          className={styles.footerButton}
          onClick={onNext}>
          {TEXTS.NEXT}
        </Button>
      </ResponsiveDialog.Footer>
    </ResponsiveDialog>
  );
};

export default AdCampaignStepperMedia;
